import gql from 'graphql-tag'
import { fragment } from './getClosing'

export default gql`
mutation cancellBill($id: ID!, $date: DateTime!, $reason: String) {
	cashAssist {
	  invalidateClosing(id: $id, date: $date, reason: $reason) {
	    ...getClosingFragment
	  }
	}
}
${fragment}`

